import { Combo } from './components/BPCHandMatrix/HandMatrix';

export const ALL_SEATS = [
  'smallBlind',
  'bigBlind',
  'utg',
  'utg1',
  'utg2',
  'utg3',
  'lowJack',
  'highJack',
  'cutoff',
  'button',
] as const;
export type Seat = (typeof ALL_SEATS)[number];

export const rangeTypes = [
  'openFold',
  'openCall',
  'open4bet',
  'open4betAllIn',
  'allIn',
  'open',
  'openLoose',
  'openTight',
  'flat',
  'threeBet',
  'threeBetLight',
  'defenseSolide',
  'defenseMoyenne',
  'defenseLight',
  'check',
] as const;
export type RangeType = (typeof rangeTypes)[number];

export const rangeCategories = ['Open', 'Call/3bet'] as const;
export type RangeCategory = (typeof rangeCategories)[number];

export type PokerRangePosition = {
  table?: number;
  seats: Seat[];
  versus?: Seat[];
};

type ComboForRangeTypeFirebase = Partial<Record<RangeType, number>>;
export type ComboForRangeType = { type: RangeType; weight: number };
export type PokerRangeFirebase = {
  id: string;
  name?: string;
  category: RangeCategory;
  positions: PokerRangePosition[];
  stack?: { min: number; max?: number };
  note?: string; //taille de la relance par exemple
  details: Partial<Record<Combo, ComboForRangeTypeFirebase>>;
};

export type PokerRange = PokerRangeFirebase;

export type ComboType = 'offsuit' | 'suited' | 'pocketPair';
